<template>
  <div class="empty-state text-center">
    <img
      src="../assets/icono_clases.svg"
      class="mb-4 mt-14"
      width="40px"
      height="33px"
      alt=""
    />
    <span class="empty-title text-skin-primary">{{ textEmpty }}</span
    ><br />
    <span class="empty-text text-skin-primary">{{ textDescript }}</span>
  </div>
</template>

<script>
export default {
  props: {
    textEmpty: {
      required: true,
      type: String,
    },
    textDescript: {
      required: true,
      type: String,
    },
  },
};
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.empty-title {
  text-align: center;
  font: normal normal normal 16px/19px Roboto;
  letter-spacing: 0px;
  opacity: 1;
}

.empty-text {
  text-align: center;
  font: normal normal normal 13px/15px Roboto;
  letter-spacing: 0px;
  opacity: 1;
}
</style>
